import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useWillUnmount } from 'rooks';
import { END_OF_QUESTS_MODAL_SEEN_KEY } from 'root/lib/constants';
import { markSeenInSession } from 'root/lib/modalSessionUtils';
import { getProduct } from 'a/selectors/languageSelectors';
import MedalOfOlviaSvg from './svgs/MedalOlivia.svg';
import BackgroundSvg from './svgs/Background.svg';
import BurstSvg from './svgs/Burst2.svg';
import ContinueButtonSvg from './svgs/ContinueButton.svg';
import {
  markAllQuestsAndChallengesComplete,
  goToPractice,
  saveWorkshopProgress,
} from '../../../../../actions/workshopActions';
import useWorkshopSfx from '../../../hooks/useWorkshopSfx';
import { Medal, ModalBox, Burst, TitleText, DescriptionText, StyledImageButton } from './styledComponents';

const EndOfAllQuestsAndChallengesModal = ({ closeModal }) => {
  const dispatch = useDispatch();
  const product = useSelector(getProduct);
  const { playTap } = useWorkshopSfx();
  const clickedRef = useRef(false);
  const timeout = useRef(null);
  const onClickHandler = () => {
    if (clickedRef.current) return;
    clickedRef.current = true;
    playTap(true);
    timeout.current = setTimeout(() => {
      markSeenInSession(END_OF_QUESTS_MODAL_SEEN_KEY, product);

      dispatch(markAllQuestsAndChallengesComplete());
      dispatch(saveWorkshopProgress());
      dispatch(goToPractice({ trigger: 'endOfAllQuestsAndChallengesModal' }));
      closeModal();
    }, 150);
  };

  useWillUnmount(() => {
    clearTimeout(timeout.current);
  });

  const titleText = 'All Challenge Quests Complete!';

  const descriptionText =
    'You have earned the title of Quest\n' +
    'Buster Supreme. But, you can still\n' +
    'develop your skills further by\n' +
    'playing games in the Practice Zone!\n' +
    'Click on the three dots at the upper\n' +
    'right for unlimited access to any of\n' +
    'the games.';

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="end-challenge-modal-title"
      data-dd-action-name="workshop-end-of-all-quests-modal"
    >
      <ModalBox src={BackgroundSvg} alt="" />
      <h2 className="sr-only" id="end-challenge-modal-title">Success</h2>
      <Burst src={BurstSvg} alt="" />
      <Medal src={MedalOfOlviaSvg} alt="Medal" />
      <TitleText as="h2"> {titleText} </TitleText>
      <DescriptionText as="p"> {descriptionText} </DescriptionText>
      <StyledImageButton
        onClick={onClickHandler}
        src={ContinueButtonSvg}
        accessibilityLabel="Go To Practice"
        data-dd-action-name="workshop-end-of-all-quests-modal:continue"
      />
    </div>
  );
};

EndOfAllQuestsAndChallengesModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default EndOfAllQuestsAndChallengesModal;
